<template>
  <div class="button-group" >
    <v-btn color="valid"
           @click="$emit('save')">
      {{ $t('components.buttons.save') }}
    </v-btn>
    <v-btn v-if="!isModification && !justSave" @click="$emit('save', 'New')"
           color="other1"
    >
      {{ $t('components.buttons.saveNew') }}
    </v-btn>
    <v-btn v-if="!justSave" @click="$emit('save', 'Continue')"
           color="other2"
    >
      {{ $t('components.buttons.saveContinue') }}
    </v-btn>
    <v-btn color="cancel" @click="cancel">
      {{ $t('components.buttons.cancel')}}
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'saveButtons',
  props: {
    isModification: {
      required: true,
      type: Boolean
    },
    justSave: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel () {
      this.$router.push({ name: 'questionsList' })
    }
  }
}

</script>

<style lang="scss" scoped>
  .button-group {
    margin-top: 30px;
    display: flex;
    flex-direction: column;

    .v-btn{
      margin: 6px 30px;
    }
  }
</style>
